import { Helmet } from "react-helmet-async"; // <-- Ajout de Helmet pour le SEO
import API from "../services/api";
import "../styles/VipPage.css";

function VipPaymentPage() {
  // Définir ici si le service est actif ou non (pour synchroniser le bouton et le message)
  const isServiceAvailable = false; 

  const handleVipPayment = async () => {
    if (!isServiceAvailable) {
      alert("Ce service n'est pas disponible pour le moment.");
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user) {
        alert("Veuillez vous connecter pour acheter un abonnement.");
        return;
      }

      // Utilisation de la configuration dynamique de l'instance API
      const response = await API.post("/create-payment", {
        email: user.email,
        amount: 1.99
      });

      if (response.data?.link) {
        window.location.href = response.data.link;
      } else {
        alert("Impossible de générer le lien de paiement.");
      }
    } catch (error) {
      console.error("Erreur lors de l'initialisation du paiement:", error);
      alert("Une erreur est survenue, veuillez réessayer.");
    }
  };

  return (
    <div className="vip-page">
      {/* --- BLOC REFERENCEMENT / SEO --- */}
      <Helmet>
        <title>Abonnement FootVision VIP - Compos des matchs Analyses & Pronostics Premium</title>
        <meta name="description" content="Passez au niveau supérieur avec FootVision VIP pour seulement 1.99$/mois. Accédez aux analyses avancées, pronostics exclusifs, compositions d'équipes et alertes en direct." />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Devenir Membre VIP – FootVision" />
        <meta property="og:description" content="Débloquez l'accès complet : pronostics premium, outils d'analyses de cotes et alertes exclusives par carte ou Mobile Money." />
        <meta property="og:url" content="https://www.footvisionlive.com/vip" />
        <meta property="og:image" content="https://www.footvisionlive.com/logo2.png" />
      </Helmet>

      <div className="vip-card">
        <h1>FootVision VIP</h1>
        <h2>1.99$ / mois</h2>
        
        <ul>
          <li>✔ Analyses avancées</li>
          <li>✔ Pronostics premium</li>
          <li>✔ Compositions des matchs</li>
          <li>✔ Signaux premium et alertes avancées</li>
          <li>✔ Accès complet</li>
        </ul>
        
        <p style={{ color: "var(--white)" }}>
          Paiement par carte ou mobile money (Airtel money, Orange money, etc...)
        </p>
        
        <button 
          onClick={handleVipPayment}
          disabled={!isServiceAvailable}
          style={{ opacity: isServiceAvailable ? 1 : 0.6, cursor: isServiceAvailable ? "pointer" : "not-allowed" }}
        >
          Payer maintenant
        </button>

        {!isServiceAvailable && (
          <h3 className="service-unavailable-msg">
            Ce service n'est pas disponible pour le moment.
          </h3>
        )}
      </div>
    </div>
  );
}

export default VipPaymentPage;